import type { BaseKeyFunction } from "../../../lib";

export const keyMe: BaseKeyFunction = () => ["me"];
